module.exports = __webpack_public_path__ + "img/kwaimePhone.9918db3.png";